<template>
    <svg v-if="switchStatus" class="cursor_pointer" :width="widthSwitch" :height="heightSwitch" @click.prevent="clickSwitch" viewBox="0 0 60 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="8" width="60" height="32" rx="16" fill="url(#paint0_linear_998_3236)" fill-opacity="0.7"/>
        <rect y="8" width="60" height="32" rx="16" fill="url(#paint1_radial_998_3236)" fill-opacity="0.2"/>
        <rect x="32" y="12" width="24" height="24" rx="12" fill="white"/>
        <defs>
            <linearGradient id="paint0_linear_998_3236" x1="-3.93484e-08" y1="25" x2="51.9169" y2="22.3636" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF4F28" stop-opacity="0.87"/>
                <stop offset="1" stop-color="#FFBAA4"/>
            </linearGradient>
            <radialGradient id="paint1_radial_998_3236" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(26 24.6667) rotate(-131.789) scale(8.94126 10.5208)">
                <stop stop-color="white"/>
                <stop offset="1" stop-color="white" stop-opacity="0"/>
            </radialGradient>
        </defs>
    </svg>

    <svg v-else class="cursor_pointer" :width="widthSwitch" :height="heightSwitch" @click.prevent="clickSwitch" viewBox="0 0 60 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="9" width="56" height="30" rx="16" fill="#E7E0EC" stroke="#79747E" stroke-width="2"/>
        <rect x="6" y="12" width="24" height="24" rx="16" fill="#79747E"/>
    </svg>

</template>

<script>

export default {
    name: "switch_block",
    props: {
        switchStatus: {
            type: Boolean,
            required: true
        },
        width: {
            type: Number,
            required: false,
        },
        height: {
            type: Number,
            required: false,
        }
    },
    emits: ['click_switch'],
    components: {},
    mixins: [],
    data() {
        return {
            widthSwitch: 52,
            heightSwitch: 32
        }
    },
    created() {
        if(this.width){
            this.widthSwitch = this.width;
        }
        if(this.height){
            this.heightSwitch = this.height;
        }
    },
    methods: {
        clickSwitch(){
            this.$emit('click_switch', !this.switchStatus);
        }
    },
    computed: {
        refSvg() {
            if (this.switchStatus) {
                return '/icons/base.svg#switch_on';
            }
            return '/icons/base.svg#switch_off';
        }
    },
}
</script>
